import React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '@/components/ButtonBase';
import useStyle from './style';
import cx from '@/utils/cx';

const WheelChooseItem = ({
  children,
  content,
  onItemClick,
  className,
  ...rest
}) => {
  const classes = useStyle();

  return (
    <ButtonBase
      size="md"
      fullWidth
      className={cx(classes.wheelChooseItem, className)}
      onClick={()=> onItemClick(content)}
      aria-label={content}
      tabIndex={rest.key}
      {...rest}
    >
      {children}
    </ButtonBase>
  );
};

WheelChooseItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.any.isRequired,
  onItemClick: PropTypes.func,
};
WheelChooseItem.defaultProps = {
  onItemClick: ()=>{}
};

export default WheelChooseItem;
